<template>
	<div ref="el" data-component="feature-point">
		<div class="icon">
			<Icon slug="solution" size="s" />
		</div>
		<div>
			<SanityContent :blocks="description" />
		</div>
	</div>
</template>

<script setup>
import { Icon } from '~/components/core'

const props = defineProps({
	description: { type: Array, default: undefined },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {})
</script>

<style lang="scss" scoped>
[data-component='feature-point'] {
	position: relative;

	display: flex;
	flex-direction: row;
	gap: rs(16, 12);

	@include text-2;
	color: rgb(from var(--color-geral-brown) r g b / 0.5);

	@include max-width($sm) {
		@include text-4;
	}

	@include max-width($xs) {
		@include text-2;
	}

	:deep(strong) {
		@include title-3;
		color: var(--color-geral-brown);

		@include max-width($sm) {
			font-size: rs(32, 24);
		}

		@include max-width($xs) {
			font-size: rs(48, 28);
		}
	}

	:deep(p:not(:last-child)) {
		padding-bottom: rs(12, 6);

		@include max-width($sm) {
			padding-bottom: rs(7, 2);
		}

		@include max-width($xs) {
			padding-bottom: rs(12, 6);
		}
	}

	.icon {
		padding-top: rs(12, 6);

		@include max-width($sm) {
			padding-top: rs(7, 2);
		}

		@include max-width($xs) {
			padding-top: rs(12, 6);
		}
	}
}
</style>
